import Box from "@mui/material/Box";
import WizardStep from "../../../../components/Wizard/WizardStep"
import useICPWizard from "../hooks/useICPWizard";
import { ReactNode } from "react";
import Typography from "@mui/material/Typography";
import { Sprint } from "../../../../stores/SprintStore";
import ICPLeadList from "./ICPLeadList";
import { GridFilterItem, GridLinkOperator } from "@mui/x-data-grid-pro";

type Props = {
    onCancel: () => void,
    steps: ReactNode
}

const RefineICPFilters = ({ onCancel, steps }: Props) => {
    const { handleNextStep, handlePreviousStep, sprint, icp, onICPChange } = useICPWizard();

    const handleGridStateChange = (newFilters: GridFilterItem[], linkOperator: GridLinkOperator) => {
        onICPChange({
            ...icp,
            refinedFilters: newFilters,
            refinedFiltersLinkOperator: linkOperator
        });
    }



    return (
        <WizardStep
            title="ICP Builder - Refine Filters"
            subtitle="Ideal Customer Profile"
            onNext={handleNextStep}
            onPrevious={handlePreviousStep}
            onCancel={onCancel}
        >
            <Box display='flex' sx={{ height: '100%' }}>
                {steps}
                <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', rowGap: 4, width: '100%' }}>
                    <Box display='flex' flexDirection='column' rowGap={1}>
                        <Typography variant='body2'>Use the data grid filters to refine your profile.</Typography>
                    </Box>
                    <ICPLeadList
                        onGridStateChange={handleGridStateChange}
                        filter={icp.primaryFilters}
                        sprint={sprint}
                        selectedSprintId={sprint.id}
                        onLeadSelected={(leadId: string) => { alert(leadId) }}
                        unassignedOnly={false}
                    />
                </Box>
            </Box>
        </WizardStep>
    )
}

export default RefineICPFilters;